import React from 'react';
import { useLocation } from "react-router-dom";
import LabsAppBar from "../../components/LabsAppBar";
import { ActionButton } from '../../components/LabsAppBar';

const StarterKitsPage: React.FC = () => {
  const location = useLocation();

  let breadcrumbs = [];
  let actions: ActionButton[] = [];
  let pageTitle = '';
  let pageIcon: string | undefined;

  switch (location.pathname) {
    case '/labs/starter-kits':
      pageTitle = 'Starter Kits';
      pageIcon = 'Package';
      actions = [
        { label: 'New Starter Kit', onClick: () => console.log('New Starter Kit clicked'), iconName: 'PlusCircle', variant: 'primary' },
      ];
      break;
    default:
      pageTitle = 'Starter Kits';
      pageIcon = 'Package';
      actions = [];
      break;
  }

  breadcrumbs = [{ name: pageTitle, iconName: pageIcon }];

  return (
    <div className="flex flex-col h-full">
      <LabsAppBar
        breadcrumbs={breadcrumbs}
        actions={actions}
      />
      <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
        <div className="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Future home of the Starter Kit Builder</h2>
          <p className="text-gray-700 dark:text-gray-300">Integrations team’s go-to tool for crafting polished starter kits, faster. Drop in components, tweak configs, and ship with confidence.</p>
        </div>
      </div>
    </div>
  );
};

export default StarterKitsPage;
